import { createResource, createEndpoint } from './Schema';
import { SessionModel } from './Schema/Models';
import api from './Schema/Api';

/*
 * static s'applique au model
 * methods s'applique à la resource
 */
const sync = false;
const methods = {};

const SessionResource = createResource(api, SessionModel, {
  static: { sync },
  methods,
});

export const Session = createEndpoint(SessionResource, '', { static: {} });
